const getPageNumberArray = (lastPage: number): string[] =>
  Array(lastPage)
    .fill(undefined)
    .map((_, index) => (index + 1).toString());

export const ELLIPSIS = '…';
const MAX_AMOUNT_OF_STRINGS_TO_DISPLAY = 8;

type Options = {
  currentPage: number;
  lastPage: number;
};

export const getPaginationStringsToDisplay = ({ currentPage, lastPage }: Options) => {
  const pageNumbers = getPageNumberArray(lastPage);
  const maxAmountOfPagesExceeded = pageNumbers.length > MAX_AMOUNT_OF_STRINGS_TO_DISPLAY;

  const currentPageIndex = currentPage - 1;

  const needsFrontEllipsis = maxAmountOfPagesExceeded && currentPageIndex > 2; // this ensure that we always can show at least 2 digits in front
  const needsBackEllipsis = maxAmountOfPagesExceeded && currentPageIndex < pageNumbers.length - 4;

  const finalStrings: string[] = [];

  let lowerIndex: number = 0;
  let upperIndex: number = pageNumbers.length;

  if (needsFrontEllipsis && needsBackEllipsis) {
    lowerIndex = currentPageIndex - 1;
    upperIndex = currentPageIndex + 3;
  } else if (needsFrontEllipsis && !needsBackEllipsis) {
    lowerIndex = pageNumbers.length - 5;
    upperIndex = pageNumbers.length;
  } else if (!needsFrontEllipsis && needsBackEllipsis) {
    lowerIndex = 0;
    upperIndex = 5;
  }

  if (needsFrontEllipsis) {
    finalStrings.push(pageNumbers[0], ELLIPSIS);
  }

  finalStrings.push(...pageNumbers.slice(lowerIndex, upperIndex));

  if (needsBackEllipsis) {
    finalStrings.push(ELLIPSIS, pageNumbers[pageNumbers.length - 1]);
  }

  return finalStrings;
};
